import { ContactCenterLogo } from '@components/ContactCenterLogo';
import { StackItem, BodyText, Stack } from '@servicetitan/design-system';
import { Button } from '@servicetitan/anvil2';

export interface ErrorPageViewProps {
  error?: {
    statusText?: string;
    message?: string;
  };
  onNavigate: () => void;
}

export const ErrorPageView = ({ error, onNavigate }: ErrorPageViewProps) => {
  return (
    <Stack
      alignContent='center'
      className='h-100vh'
      direction='column'
      justifyContent='center'
      spacing={4}
    >
      <StackItem alignSelf='center'>
        <ContactCenterLogo showIcon />
      </StackItem>
      <StackItem alignSelf='center' className='ta-center'>
        <BodyText bold size='large' className='m-b-2'>
          An error has occured!
        </BodyText>
        <BodyText data-selector='error-text' className='m-t-half c-red'>
          {error?.statusText || error?.message}
        </BodyText>
        <Stack className='m-t-2' justifyContent='center'>
          <Button
            data-testid='ErrorPage-RecoverButton'
            appearance='primary'
            onClick={onNavigate}
          >
            Go to Inbox
          </Button>
        </Stack>
      </StackItem>
    </Stack>
  );
};
